import { render, staticRenderFns } from "./DeliveryOrderView.vue?vue&type=template&id=2ee24558&scoped=true"
import script from "./DeliveryOrderView.vue?vue&type=script&lang=js"
export * from "./DeliveryOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee24558",
  null
  
)

export default component.exports